import ButtonCinestar from '../../../../../Buttons/ButtonCinestar/ButtonCinestar'

import './TopProgramMenu.scss'

const TopProgramMenu = ({ programHandleClick, menuHandleClick }) => {
    return (
        <div className="top-program-menu text-white">
            <ButtonCinestar variant="secondary" className="border-0" onClick={programHandleClick}>
                Program
            </ButtonCinestar>
            <ButtonCinestar variant="secondary" iconRight="hamburger" className="border-0" onClick={menuHandleClick}>
                Menu
            </ButtonCinestar>
        </div>
    )
}

export default TopProgramMenu
